import React from 'react';
import { vFParamsPropShape } from './data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-section-header.css';
// import 'AppSrc/core/style/components/form/form-base-components/v-f-sub-section-title.css';


const VFSubSectionTitle1 = React.memo(({
  vFParams,
}) => {
  const {
    fieldTitle,
  } = vFParams;
  return (
    <h4 className="v-f-sub-section-title1">{fieldTitle}</h4>
  );
});

VFSubSectionTitle1.propTypes = {
  vFParams: vFParamsPropShape,
};

const VF_SUB_SECTION_TITLE1 = 'v-f-sub-section-title1';

export {
  VF_SUB_SECTION_TITLE1,
  VFSubSectionTitle1,
};
